import gql from "graphql-tag";
import { DocumentNode, PureQueryOptions } from "@apollo/client";
import { GraphQlQueryBuilder } from "./graphQl-query.builder";
interface TipoDatoTableFieldGraphQL {
  tableId: string;
}
export class TipoDatoTableFieldGQlBuilder {
  private _tableId: string;
  private get _query(): DocumentNode {
    return gql`query findTipoDatoTableFields($tableId:String){
            findTipoDatoTableFields(uuidTable:$tableId){
                ${this.getNestedColumn(5)}
            }
          }`;
  }

  public getNestedColumn(maxLevel: number) {
    let startFields: string = `uuid,
        nombre,
        nombre_en,
        nombre_es,
        codigo,
        tipo,
        isUnique,
        isEditable,
        hidden,
        codigo_df,
        isRequired`;

    for (let index = 0; index < maxLevel; index++) {
      startFields =
        startFields +
        `,definitions {
                uuid,
                nombre,
                nombre_en,
                nombre_es,
                codigo,
                tipo,
                isUnique,
                isEditable,
                hidden,
                codigo_df,
                isRequired`;
    }

    if (maxLevel > 1) {
      for (let index = 0; index < maxLevel; index++) {
        startFields = startFields + "}";
      }
    }

    return startFields;
  }

  public withTableId(tableId: string): this {
    this._tableId = tableId;
    return this;
  }

  public build(): PureQueryOptions {
    let queryParams: TipoDatoTableFieldGraphQL;
    const graphQlBuilder: GraphQlQueryBuilder = new GraphQlQueryBuilder();
    queryParams = { tableId: this._tableId };
    return graphQlBuilder
      .withQuery(this._query)
      .withParams(queryParams)
      .build();
  }
}
